import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DisplayWithHealthDto } from '../../../../api/gen';
import { LayoutMode } from '../../../../api/gen/model/layoutMode';

@Component({
  selector: 'app-create-template-item',
  standalone: true,
  imports: [FormsModule, MatButtonModule, MatCardModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule],
  templateUrl: './create-template-item.component.html',
  styleUrl: './create-template-item.component.scss'
})
export class CreateTemplateItemComponent {
  @Input() display!: DisplayWithHealthDto;
  @Input() saving = false;
  @Output() create = new EventEmitter<{ name: string; layoutMode: LayoutMode }>();

  templateName = '';
  templateLayoutMode: LayoutMode = LayoutMode.SlotBased;
  readonly layoutModes = Object.values(LayoutMode);

  submit(): void {
    if (!this.templateName.trim()) return;
    this.create.emit({ name: this.templateName.trim(), layoutMode: this.templateLayoutMode });
  }
}
